import React, { useState } from 'react';
import { Box, Button, Typography, Paper, Fade } from '@mui/material';
import BaseRound from './BaseRound';
import { useGame } from '../../contexts/GameContext';

const questions = [
  "heute schon Luft geatmet?",
  "irgendwann mal Wasser getrunken?",
  "mindestens einmal im Leben geblinzelt?",
  "schon mal geschlafen?",
  "jemals einen Schatten geworfen?",
  "Blut, das durch die Adern fließt?",
  "irgendwann mal Geräusche gehört?",
  "irgendwann mal etwas gerochen?",
  "schon mal eine Treppe benutzt?",
  "irgendwann mal seinen eigenen Namen gehört?",
  "jemals einen Gegenstand angefasst?",
  "irgendwann mal eine Tür geöffnet oder geschlossen?",
  "schon mal eine Entscheidung getroffen?",
  "mindestens eine Sekunde lang existiert?",
  "irgendwann mal eine Frage gestellt?",
  "schon mal eine Antwort bekommen?",
  "irgendwann mal gelächelt (auch unbewusst)?",
  "irgendwann mal geblinzelt, ohne es zu merken?",
  "mindestens ein Wort gedacht, ohne es auszusprechen?",
  "schon mal etwas vergessen?",
  "mindestens eine Emotion gespürt?",
  "irgendwann mal Hunger oder Durst gehabt?",
  "sich mindestens einmal in seinem Leben bewegt?",
  "jemals einen anderen Menschen gesehen?",
  "irgendwann mal etwas Neues gelernt?",
  "irgendwann mal einen Ton von sich gegeben?",
  "schon mal geschwitzt?",
  "irgendwann mal einen Traum gehabt?",
  "sich mindestens einmal in seinem Leben erschrocken?",
  "mindestens einmal über etwas nachgedacht?",
  "irgendwann mal eine Farbe gesehen?",
  "schon mal Zeit gebraucht, um über eine Frage nachzudenken?",
  "irgendwann mal ein Objekt verloren oder verlegt?",
  "mindestens ein Wort gelesen?",
  "irgendwann mal gewartet?",
  "irgendwann mal ein Geräusch gemacht, ohne es zu bemerken?",
  "sich mindestens einmal in seinem Leben gefragt, was als nächstes passiert?",
  "mindestens eine Erinnerung an die Vergangenheit?",
  "irgendwann mal die Zukunft geplant?",
  "schon mal einen Menschen beobachtet, ohne dass er es gemerkt hat?",
  "mindestens einmal einen Gegenstand hochgehoben?",
  "irgendwann mal einen Gedanken zu Ende gedacht?",
  "schon mal in den Himmel geschaut?",
  "mindestens eine Sekunde in Stille verbracht?",
  "irgendwann mal in einem Raum gestanden?",
  "mindestens einmal darüber nachgedacht, was andere von einem denken?",
  "schon mal bemerkt, dass die Zeit schnell vergeht?",
  "irgendwann mal vergessen, warum man einen Raum betreten hat?",
  "irgendwann mal etwas für selbstverständlich gehalten?",
  "irgendwann mal gedacht: 'Das geht zu schnell'?"
];

export default function WhoHasRound() {
  const [currentQuestion, setCurrentQuestion] = useState(() => 
    questions[Math.floor(Math.random() * questions.length)]
  );
  const [showResult, setShowResult] = useState(false);
  const { state } = useGame();

  const handleReveal = () => {
    setShowResult(true);
  };

  const resultData = showResult ? {
    title: `Wer hat ${currentQuestion}`,
    success: false,
    drinks: 2,
    player: state.activePlayer,
    points: 0
  } : null;

  return (
    <BaseRound
      instructions={`${state.activePlayer}, decke die Frage auf und alle, die es betrifft, müssen trinken!`}
      showResult={showResult}
      resultData={resultData}
    >
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
        {!showResult && (
          <Button
            variant="contained"
            color="secondary"
            onClick={handleReveal}
            sx={{ py: 3, fontSize: '1.2rem' }}
          >
            Frage aufdecken
          </Button>
        )}
      </Box>
    </BaseRound>
  );
} 